module.exports = __webpack_public_path__ + "img/request-demo.f33448b2.svg";